import { startSlider } from './config.js';

export const initAboutCompanyTeam = () => {
    const sections = document.querySelectorAll('[data-team-section]');

    if (!sections.length) {
        return;
    }

    const mobile = window.matchMedia('(max-width: 600px)');

    sections.forEach((section) => {
        const slider = section.querySelector('[data-team-slider]');
        const previous = section.querySelector('[data-team-prev]');
        const next = section.querySelector('[data-team-next]');

        if (!slider) {
            return;
        }

        const wrapper = slider.querySelector('.swiper-wrapper');
        const originalSlides = Array.from(slider.querySelectorAll('.swiper-slide'));

        if (!wrapper || !originalSlides.length) {
            return;
        }

        const syncSlider = () => {
            if (mobile.matches) {
                slider.swiper?.destroy(true, true);
                return;
            }

            if (!slider.swiper) {
                startSlider(slider, {
                    loop: false,
                    slidesPerGroup: 1,
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    speed: 500,
                    grabCursor: true,
                    navigation: {
                        prevEl: previous,
                        nextEl: next,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                });
            }
        };

        syncSlider();
        mobile.addEventListener('change', syncSlider);
    });
};
